export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('truncate', {
    mounted (el, binding) {
      nextTick(() => {
        const maxHeight = binding.value || 330
        const originalText = el.innerText.trim()

        function truncateText (element: HTMLElement) {
          element.innerText = originalText

          if (element.scrollHeight <= maxHeight) {
            return
          }

          let text = originalText
          element.innerHTML = text

          while (element.scrollHeight > maxHeight && text.length > 0) {
            text = text.slice(0, -1).trim()
            element.innerHTML = text + '...'
          }
        }

        truncateText(el)
      })
    },
  })
})
